var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShieldWithV = function SvgShieldWithV(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00C48C",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.827 20.025c0 4.706-2.65 8.174-10.397 13.416C5.683 28.2 3.032 24.731 3.032 20.025V8.094C6.885 7.686 9.97 6.382 13.43 3.718c3.461 2.664 6.545 3.968 10.397 4.375v11.932zm2.275-14.767c-4.557-.103-7.69-1.194-12.103-4.933-.158-.134-.364-.202-.57-.202-.205 0-.41.068-.569.202C8.448 4.064 5.315 5.155.76 5.258.339 5.268 0 5.6 0 6.01v14.016c0 6.814 4.65 11.223 12.8 16.591.173.115.402.172.63.172.228 0 .456-.057.63-.172 8.149-5.368 12.8-9.777 12.8-16.59V6.008c0-.41-.34-.742-.758-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.416 16.99c-.31-.268-.816-.265-1.121.008l-.986.88c-.307.272-.302.713.01.981l4.056 3.484c.041.035.085.065.132.09.308.183.733.156 1.005-.083l7.086-6.2c.309-.27.309-.712 0-.981l-.995-.871c-.308-.27-.814-.27-1.122 0l-5.547 4.853-2.518-2.162z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldWithV, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield_with_v.3cf5e9bf.svg";
export { ForwardRef as ReactComponent };